import { render, staticRenderFns } from "./waterFeeRecord.vue?vue&type=template&id=6060fe4c&"
import script from "./waterFeeRecord.vue?vue&type=script&lang=js&"
export * from "./waterFeeRecord.vue?vue&type=script&lang=js&"
import style0 from "./waterFeeRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports